import {call, put, takeLatest} from 'redux-saga/effects';
import {AUTH_GOOGLE_ACTION, AUTH_GOOGLE_WITH_CODE_ACTION} from './constants';
import {authError} from './actions';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {redirectToFirstPage, redirectToLoginPage} from 'feedback-system/utils';

interface Parameters {
    code: string;
    type: string;
}

function* authGoogle() {
    const data = yield call(Api.fetch, {
        endpoint: 'auth/getlink',
        method: ApiMethods.GET
    });

    location.href = data.responseData.url;
}

export function* authSagaGoogle() {
    yield takeLatest(AUTH_GOOGLE_ACTION, authGoogle);
}

function* authGoogleWithCode(inputParameters: Parameters) {
    try {
        const dataToken = yield call(Api.fetch, {
            endpoint: `auth/logingoogle?code=${inputParameters.code}`,
            method: ApiMethods.GET
        });
        if (dataToken.httpStatus === 200 && dataToken.responseData.token) {
            localStorage.setItem('accessToken', dataToken.responseData.token);
            redirectToFirstPage();
        } else {
            redirectToLoginPage();
        }
    } catch (error) {
        yield put(authError());
    }
}

export function* authSagaGoogleWithCode() {
    yield takeLatest(AUTH_GOOGLE_WITH_CODE_ACTION, authGoogleWithCode);
}
